import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import { Documents } from ".";
import { useParams } from "react-router-dom";

export const ChartPie = ({ data }: Documents) => {
  const { getSizesComponent,componentProperty, generateRedirectUrl } =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(200);
  const [widthChart, setWidthChart] = useState(200);
  const [labels, setLabels] = useState<string[]>([]);
  const [dataChart, setDataChart] = useState<number[]>([]);
  const { mode } = useParams();

  useEffect(() => {
      setLabels(["Finalizado", "Não Finalizado"]);

      setDataChart([data.Entregue, data.total - data.Entregue].map(element => {return Number(element)}))
  }, [data]);

  const getPositionLegend = (width: number, height: number): 'right' | 'bottom' => {
    if (width < 250 || height / width > 1.5) {
      return "bottom"
    } else {
      return "right";
    }
};


const options: ApexOptions = {
  chart: {
    animations: {
      dynamicAnimation: {
        enabled: true,
        speed: 350,
      },
      enabled: false,
    },
    type: "pie",
    events: {
      dataPointSelection: async (event, chartContext, config) => {
        const selected = labels[config.dataPointIndex];
        let status = [];

        if(selected === 'Finalizado'){
          status = [3,4,8];
        } else {
          status = [0,1,2,5,6,7,9,10,11,12,13,15,17,18,20]
        }
    
        if (
          mode === "view" 
          &&
          componentProperty({
            id: "chartDocumentsDeliveredPerSla",
            property: "redirect",
          })
        ) {
          window.open(
            await generateRedirectUrl("chartDocumentsDeliveredPerSla", {
              redirectTowerToIndex: true,
              date: true,
              slaDate: true,
              status_stop_id: status
            }),
            "_blank"
          );
        }
      },
    },
  },
  stroke: {
    colors: undefined,
  },
  labels: labels,
  colors: ["#01B8AA", "#808080"],
  responsive: [
    {
      breakpoint: 480,
      options: {
        legend: {
          position: "bottom",
        },
      },
    },
  ],
  legend: {
    position: getPositionLegend(widthChart, heightChart),
  },
};

  const series = [...dataChart];

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-documents-delivered-per-sla" });
    if(sizes.width < 250){
      setHeightChart(sizes.height-50);
    }else{
      setHeightChart(sizes.height-(0.20*sizes.height));
    }
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, []);

  return completeRequisition ? (
    <div className="h100 component-height">
      <HeaderComponent
        title={`Porcentagem de entregas por SLA`}
        clickable={componentProperty({
          id: "chartDocumentsDeliveredPerSla",
          property: "redirect",
        })}
        id="chart-documents-delivered-per-sla"
      />
      <div id="chart" className="component-content">
        <Chart
          type="pie"
          options={options}
          series={series}
          height={heightChart}
          width={widthChart}
        />
      </div>
    </div>
  ) : (
    <></>
  );
};
